import { apiRequest } from '../http/httpClient';

let catalogCache = null;
let catalogInFlightPromise = null;

// El nombre de Shopify suele traer el peso/tamaño al final (ej. "Pop Corn 10g",
// "3x Filtre 2g"): lo extraemos para mostrarlo, en vez de inventarlo.
function extractWeightFromName(name = '') {
  const match = name.match(/(\d+(?:[.,]\d+)?\s?(?:kg|g|ml|mg))\s*$/i);
  return match ? match[1] : '';
}

function mapProduct(product) {
  return {
    id: product.id,
    name: product.name,
    description: product.description || '',
    price: Number(product.price || 0),
    cbdPercentage: Number(product.cbdPercentage || 0),
    thcPercentage: Number(product.thcPercentage || 0),
    ohTenPercentage: Number(product.ohTenPercentage || 0),
    msPercentage: Number(product.msPercentage || 0),
    nano10Percentage: Number(product.nano10Percentage || 0),
    deltaHcPercentage: Number(product.deltaHcPercentage || 0),
    stock: Number(product.stock || 0),
    stockUnit: 'UNIT',
    inStock: Number(product.stock || 0) > 0 && product.active !== false,
    active: product.active !== false,
    category: product.category || 'Sin categoría',
    image: product.image || '/leaf.png',
    weight: extractWeightFromName(product.name),
    createdAt: product.createdAt,
    updatedAt: product.updatedAt,
  };
}

function findInCatalogById(productId) {
  if (!catalogCache) {
    return null;
  }

  return catalogCache.find((item) => item.id === productId) || null;
}

export const productApi = {
  async listProducts() {
    if (catalogCache) {
      return catalogCache;
    }

    if (catalogInFlightPromise) {
      return catalogInFlightPromise;
    }

    catalogInFlightPromise = apiRequest('/api/products')
      .then((products) => {
        const mapped = Array.isArray(products) ? products.map(mapProduct) : [];
        // Solo se guarda en caché una respuesta con productos. Un array vacío
        // puede ser un estado transitorio y no debe "pegarse" para el resto de
        // la sesión.
        if (mapped.length > 0) {
          catalogCache = mapped;
        }
        return mapped;
      })
      .finally(() => {
        catalogInFlightPromise = null;
      });

    return catalogInFlightPromise;
  },

  async getProduct(productId) {
    const catalogProduct = findInCatalogById(productId);

    if (catalogProduct) {
      return catalogProduct;
    }

    const product = await apiRequest(`/api/products/${productId}`);
    return mapProduct(product);
  },

  preloadProducts() {
    return this.listProducts();
  },

  async listAllProductsForAdmin(token) {
    const products = await apiRequest('/api/products/all', { token });
    return Array.isArray(products) ? products.map(mapProduct) : [];
  },

  clearCatalogCache() {
    catalogCache = null;
    catalogInFlightPromise = null;
  },
};
